<template>
    <nav aria-label="breadcrumb" v-if="(path)">
        <ol class="breadcrumb spa-breadcrumb">
            <li class="breadcrumb-item" v-bind:class="{ 'active': index === path.length-1 }" v-for="(route, index) in path" v-bind:key="index">
                <router-link v-bind:to="{name: route.name}"> {{ (route.meta.linkText !== null) ? route.meta.linkText : stateTitle }} </router-link>
            </li>
        </ol>
    </nav>
</template>
<script>
export default {
  data () {
    return {
    };
  },
  computed: {
    path () {
      return getParentPath([], this.$route);
    },
    stateTitle () {
      return this.$store.state.breadCrumbTitle;
    }
  }
};

function getParentPath (initial, item) {
  initial.push(item);
  if (item.meta.parent) {
    return getParentPath(initial, item.meta.parent);
  }
  if (initial.length > 1) {
    return initial.reverse();
  }
}
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';
.main {
    background-color: $lightgray;
}
.spa-breadcrumb {
  padding-left: 0;
  margin-bottom: 0px;

  .breadcrumb-item {
    a {
      color: $sub200;
      text-decoration: none;
      font-weight: bold;
      &:hover{
        color: $blue600;
      }
    }
    &.active a {
      color: $blue600;
    }
  }
}
</style>
